module.exports = __webpack_public_path__ + "img/796425061.599e3254.png";